import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import ProductIcon from "../../assets/images/placeholder/product.png";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

interface ProductCardProps {
  product: {
    id: string;
    name: string;
    quantity: number;
    selling_price: number;
    hasDiscount?: boolean;
    discount?: number;
    hasTax?: boolean;
    images?: { url: string }[];
  };
  addToCart: (id: string) => void;
  cart: { id: string; quantity: number }[];
  removeFromCart: (id: string) => void;
}

export function ProductCard({
  product,
  addToCart,
  cart,
  removeFromCart,
}: ProductCardProps) {
  const productInCart = cart.find((item) => item.id === product.id);
  const productQuantity = productInCart ? productInCart.quantity : 0;
  const defaultCurrency = useSelector(
    (state: any) => state.Login.default_currency
  );

  const baseUrl = "/view-product/";

  return (
    <Col md={4} lg={6} xl={4} sm={6} key={"_col_" + product.id}>
      <Card>
        <CardBody>
          <div className="product-img position-relative">
            {product.hasDiscount ? (
              <div className="avatar-sm product-ribbon">
                <span className="avatar-title rounded-circle bg-primary">
                  {`- ${product.discount} %`}
                </span>
              </div>
            ) : null}

            <img
              style={{
                height: "200px",
                width: "100%",
                objectFit: "cover",
                borderRadius: "14px",
              }}
              src={
                product?.images?.length ? product.images[0].url : ProductIcon
              }
              alt={product.name}
              className="img-fluid mx-auto d-block"
            />
          </div>

          {/* Stock quantity badge*/}
          {product.quantity > 0 && (
            <div
              className="badge rounded-pill text-white position-absolute"
              style={{
                fontSize: "0.775rem",
                padding: "0.25rem 0.5rem",
                backgroundColor: "#20c997",
                top: "10px",
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: "1",
              }}
            >
              <b>{product?.quantity} in stock</b>
            </div>
          )}

          <div className="mt-4">
            <h5 className="mb-3 text-truncate">
              <Link to={`${baseUrl}${product.id}`} className="text-dark">
                {product.name}
              </Link>
            </h5>

            <h5 className="my-0">
              <b>
                {defaultCurrency} {product.selling_price.toFixed(2)}
              </b>
            </h5>
            <div className="w-100 mt-2">
              {!productQuantity ? (
                <button
                  type="button"
                  className="btn btn-light w-100 block"
                  onClick={() => addToCart(product.id)}
                >
                  Add
                </button>
              ) : (
                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ borderRadius: "0.25rem 0 0 0.25rem" }}
                    onClick={() => addToCart(product.id)}
                  >
                    <i className="bx bx-plus"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary w-100 block"
                    style={{ borderRadius: "0" }}
                  >
                    {productQuantity}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ borderRadius: "0 0.25rem 0.25rem 0" }}
                    onClick={() => removeFromCart(product.id)}
                  >
                    <i className="bx bx-minus"></i>
                  </button>
                </div>
              )}
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
